import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import AcreditacionCompletada from "@/components/AcreditacionCompletada.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";

const routes = [
  {
    path: "/",
    component: FormSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/credencial",
    name: "Credencial",
    component: CredencialSection,
  },
  {
    path: "/pagar",
    name: "Pagar",
    component: PagoSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import { createWebHashHistory } from 'vue-router'
import CredencialSection from "@/components/CredencialSection.vue";
import PagoSection from "@/components/PagoSection.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;